/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import store from '../../../store/store'

export default [
  {
    header: 'Menu',
    i18n: 'Menu',
    items: [
        {
          url: '/dash/home',
          name: 'Home',
          slug: 'home',
          icon: 'HomeIcon',
          i18n: 'Home',
          dC: true //deny for collaborator
       },       
       {
         url: null,
         name: 'Collect',
         icon: 'SendIcon',
         i18n: 'COLLECT',
         submenu: [
          {
            url: '/dash/getfeedback/sendinvites/email',
            name: 'Send Email Invites',
            slug: 'getfeedback-sendinvites-email',
            i18n: 'Send Email Invites',
            dC: false
          },
          {
           url: '/dash/getfeedback/sendinvites/text',
           name: 'Send Text Invites',
           slug: 'getfeedback-sendinvites-text',
           i18n: 'Send Text Invites',
           dC: false
         },
           {
             url: '/dash/getfeedback/qrcodelink',
             name: 'QR Code',
             slug: 'getfeedback-qrcodelink',
             i18n: 'Link & QR Code',
             dC: false
           },
           {
             url: '/dash/getfeedback/website',
             name: 'Website',
             slug: 'getfeedback-website',
             i18n: 'Website',
             dC: true
           },           
           {
             url: '/dash/getfeedback/socialmedia',
             name: 'Social Media',
             slug: 'getfeedback-socialmedia',
             i18n: 'Social Media',
             dC: false
           },
           {
             url: '/dash/getfeedback/emailsignature',
             name: 'Email Signature',
             slug: 'getfeedback-emailsignature',
             i18n: 'EmailSignature',
             dC: false
           },
           {
             url: '/dash/getfeedback/automate',
             name: 'Automate',
             slug: 'getfeedback-automate',
             i18n: 'Automate',
             dC: true
           }
         ]
       },
        {
          url: '/dash/responses',
          name: 'responses',
          //tag: 'new',
          //tagColor: 'primary',
          slug: 'responses',
          icon: 'ListIcon',
          i18n: 'VIEW',
          dC: false
      },      
      {
        url: '/dash/showcase',
        name: 'showcase',
        //tag: 'new',
        //tagColor: 'primary',
        slug: 'showcase',
        icon: 'StarIcon',
        i18n: 'SHOWCASE',
        dC: true
      },                  
      {
        url: null,
        name: 'Manage',
        icon: 'ToolIcon',
        i18n: 'Manage',
        dC: false,
        submenu: [
          {
            url: '/dash/surveyflow',
            name: 'survey-flow',
            //tag: 'new',
            //tagColor: 'primary',
            slug: 'survey-flow',
            //icon: 'RotateCwIcon',
            i18n: 'Survey Flow',
            dC: false
          },
          {
            url: '/dash/settings/lookandfeel',
            name: 'Look and Feel',
            slug: 'settings-lookandfeel',
            i18n: 'Look and Feel',
            dC: true
          },      
          {
            url: '/dash/settings/language',
            name: 'Language',
            slug: 'settings-language',
            i18n: 'Language',
            dC: true
          },           
          {
            url: '/dash/settings/collaborators',
            name: 'Collaborators',
            slug: 'settings-collaborators',
            i18n: 'Collaborators',
            dC: true
          },   
          {
            url: '/dash/settings/sharingandreviews',
            name: 'Social Platforms',
            slug: 'settings-sharingandreviews',
            i18n: 'Social Platforms',
            dC: true
          },     
          {
            url: '/dash/settings/businessinformation',
            name: 'Business Details',
            slug: 'settings-sharingandreviews',
            i18n: 'Business Details',
            dC: true
          },  
          {
            url: '/dash/settings/customdomain',
            name: 'Custom domain',
            //tag: 'new',
            //tagColor: 'primary',
            slug: 'custom-domain',
            i18n: 'Custom domain',
          },   
          {
            url: '/dash/settings',
            name: 'Settings',
            slug: 'settings',
            //icon: 'SettingsIcon',
            i18n: 'Settings',
            dC: true
          }
        ]
      },      
      /*{
        url: '/dash/help',
        name: 'Help',
        slug: 'help',
        icon: 'InfoIcon',
        i18n: 'Help'
      },*/
      
    ]
  }
]


/*

Removed 22 Feb' 21:
{
  url: '/dash/getfeedback/directLinks',
  name: 'Direct links',
  slug: 'getfeedback-directlinks',
  i18n: 'Direct Links'
},

*/
